// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog-card-page {
  background-color: rgba(var(--white));
}
.catalog-card-page__header {
  padding: 3rem 6.875rem 0;
}
@media (max-width: 768px) {
  .catalog-card-page__header {
    height: 2rem;
    padding: 2rem 1rem;
  }
}
.catalog-card-page__content {
  padding: 2rem 6.875rem 3rem;
}
@media (max-width: 768px) {
  .catalog-card-page__content {
    padding: 0;
  }
}
.catalog-card-page__title {
  font-size: 2rem;
  line-height: 1.3;
  font-weight: 500;
  color: rgba(var(--grey-800));
}
@media (max-width: 768px) {
  .catalog-card-page__title {
    font-size: 1.5rem;
    line-height: 1.3;
    padding: 0 1rem;
    margin-top: 2rem;
  }
}
.catalog-card-page__info {
  display: flex;
  gap: 2.5rem;
  margin-top: 3rem;
}
@media (max-width: 768px) {
  .catalog-card-page__info {
    margin-top: 0;
    gap: 1.5rem;
    flex-direction: column;
  }
}
.catalog-card-page__tabs {
  display: flex;
  gap: 1rem;
  padding: 1rem 0 1rem;
}
@media (max-width: 1000px) {
  .catalog-card-page__tabs {
    position: relative;
    gap: 0.5rem;
    border-bottom: none;
    overflow-x: auto;
  }
}
@media (max-width: 768px) {
  .catalog-card-page__tabs {
    padding: 0 1rem 1.5rem;
  }
}
.catalog-card-page__wrapper {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(var(--white), 0.8);
  padding: 1rem 1.5rem 1.5rem;
  mask-image: linear-gradient(to top, rgba(var(--white)) 85%, transparent);
}
.catalog-card-page__wrapper-button {
  padding: 0.75rem 1rem !important;
  height: 3rem !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/CatalogCard/styles.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;AACE;EACE,wBAAA;AACJ;AACI;EAHF;IAII,YAAA;IACA,kBAAA;EAEJ;AACF;AACE;EACE,2BAAA;AACJ;AACI;EAHF;IAII,UAAA;EAEJ;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;AACJ;AACI;EANF;IAOI,iBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,WAAA;EACA,gBAAA;AACJ;AACI;EALF;IAMI,aAAA;IACA,WAAA;IACA,sBAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,SAAA;EACA,oBAAA;AACJ;AACI;EALF;IAMI,kBAAA;IACA,WAAA;IACA,mBAAA;IACA,gBAAA;EAEJ;AACF;AAAI;EAZF;IAaI,sBAAA;EAGJ;AACF;AAAE;EACE,eAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,yCAAA;EACA,2BAAA;EACA,wEAAA;AAEJ;AAAI;EACE,gCAAA;EACA,uBAAA;AAEN","sourcesContent":[".catalog-card-page {\n  background-color: rgba(var(--white));\n\n  &__header {\n    padding: 3rem 6.875rem 0;\n\n    @media (max-width: 768px) {\n      height: 2rem;\n      padding: 2rem 1rem;\n    }\n  }\n\n  &__content {\n    padding: 2rem 6.875rem 3rem;\n\n    @media (max-width: 768px) {\n      padding: 0;\n    }\n  }\n\n  &__title {\n    font-size: 2rem;\n    line-height: 1.3;\n    font-weight: 500;\n    color: rgba(var(--grey-800));\n\n    @media (max-width: 768px) {\n      font-size: 1.5rem;\n      line-height: 1.3;\n      padding: 0 1rem;\n      margin-top: 2rem;\n    }\n  }\n\n  &__info {\n    display: flex;\n    gap: 2.5rem;\n    margin-top: 3rem;\n\n    @media (max-width: 768px) {\n      margin-top: 0;\n      gap: 1.5rem;\n      flex-direction: column;\n    }\n  }\n\n  &__tabs {\n    display: flex;\n    gap: 1rem;\n    padding: 1rem 0 1rem;\n\n    @media (max-width: 1000px) {\n      position: relative;\n      gap: 0.5rem;\n      border-bottom: none;\n      overflow-x: auto;\n    }\n\n    @media (max-width: 768px) {\n      padding: 0 1rem 1.5rem;\n    }\n  }\n\n  &__wrapper {\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    background-color: rgba(var(--white), 0.8);\n    padding: 1rem 1.5rem 1.5rem;\n    mask-image: linear-gradient(to top, rgba(var(--white)) 85%, transparent);\n\n    &-button {\n      padding: 0.75rem 1rem !important;\n      height: 3rem !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
